<template>
    <div class="option-plane">
        <div class="flex-lm">
            <div @click="drawer = true" class="button-success">筛选</div>
            <div class="tag-group" v-if="formArray.length>0">
                <span style="padding-left: 20px;">当前已选条件：</span>
                <el-tag
                        v-for="(item,key) in formArray"
                        :key="item.key" class="el-tag-fotoo" :title="item.name"
                        closable @close="closeTag(item)"
                        type="info">
                    <div class="font-more" style="max-width: 80px;float: left" :style="{maxWidth:item.key=='datetime'?'150px':'80px'}">{{ item.name }}</div>
                </el-tag>
            </div>
        </div>
        <el-drawer class="font-size14" size="544px"
                :title="draftinfo.activityName"
                :visible.sync="drawer"
                :before-close="handleClose">
            <div style="padding: 0px 20px; overflow-y: auto;height: calc(100vh - 100px);">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>筛选条件</span>
                    </div>
                    <el-form ref="form" :model="form" label-width="100px">
                        <el-form-item label="投稿列表：">
                            <el-radio-group v-model="form.group" size="mini">
                                <template v-for="item in tabs">
                                    <el-radio-button :label="item.id">{{item.name}}
                                    {{item.submissionCount>0?('('+item.submissionCount+')'):''}}
                                    </el-radio-button>
                                </template>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="征稿类型：" v-if="draftinfo.activityType=='Mixin'">
                            <el-radio-group v-model="form.type" size="mini">
                                <el-radio-button label="">
                                    全部
                                </el-radio-button>
                                <template v-for="(item,index) in draftinfo.activityMaterialTypeRefs">
                                    <el-radio-button :label="item.activityMaterialType">
                                        {{materialTypes[item.activityMaterialType]}}
                                    </el-radio-button>
                                </template>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="(draftinfo.activityAuth.trackName||'组别/赛道')+'：'" v-if="draftinfo.activityAuth.isTrack==1">
                            <el-cascader
                                    v-model="form.track" v-if="hasTrackLavelMore"
                                    :options="trackOptions" size="medium"
                                    :props="{ expandTrigger: 'hover' }"></el-cascader>
                            <el-radio-group v-model="form.track" size="mini" v-else="">
                                <el-radio-button label="">
                                    全部
                                </el-radio-button>
                                <template v-for="(item,trackIndex) in draftinfo.trackList">
                                    <el-radio-button :label="item.id">
                                        {{item.name}}
                                    </el-radio-button>
                                </template>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="(draftinfo.activityAuth.tagName||'单元/主题')+'：'" v-if="draftinfo.activityAuth.isTag==1">
                            <el-radio-group v-model="form.tag" size="mini">
                                <el-radio-button label="">
                                    全部
                                </el-radio-button>
                                <template v-for="(item,trackIndex) in draftinfo.tagList">
                                    <el-radio-button :label="item.id">
                                        {{item.name}}
                                    </el-radio-button>
                                </template>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card class="box-card" style="margin-top: 10px">
                    <el-form ref="form" :model="form" label-width="100px">
                        <el-form-item label="时间选择：">
                            <el-date-picker
                                    v-model="form.datetime"
                                    value-format="timestamp"
                                    type="datetimerange"
                                    :picker-options="pickerOptions"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="编号范围：">
                            <sn-range-input ref="snRange"
                                    v-model="form.snRange"
                                    range-separator="至"
                                    start-placeholder="请输入开始编号"
                                    end-placeholder="请输入结束编号"
                                    align="right">
                            </sn-range-input>
                        </el-form-item>
                        <el-form-item label="排序选择：">
                            <el-radio-group v-model="form.orderBy" size="mini">
                                <el-radio-button label="">
                                    按投稿顺序排序
                                </el-radio-button>
                                <el-radio-button label="likeCount">
                                    按点赞量排序
                                </el-radio-button>
                                <el-radio-button label="gainVotes">
                                    按投票数量排序
                                </el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="隐藏状态：">
                            <el-radio-group v-model="form.isHide" size="mini">
                                <el-radio-button label="">
                                    全部
                                </el-radio-button>
                                <el-radio-button label="0">
                                    未隐藏
                                </el-radio-button>
                                <el-radio-button label="1">
                                    已隐藏
                                </el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </el-card>
                <div class="flex-vc">
                    <el-button type="primary"
                               @click="handleClose(function(){drawer=false})"
                               style="margin-top: 40px; width: 160px;">
                        筛选
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>

</template>
<script>
  import App from '../../util/comfun'
  import snRangeInput from '../card/sn-range-input'
  export default {
    components: {
      //tab,
      'sn-range-input':snRangeInput,
    },
    props:{
      id:{
        type:String,
        value:'',
      },
      draftinfo:{
        type:Object,
        value:null,
      }
    },
    watch:{
      id(){
        this.init()
      },
      draftinfo(oldVal,newVal){
        if(newVal.activityId && newVal.activityId!=oldVal.activityId){
          console.log('draftinfo',newVal.activityId,oldVal.activityId)
          this.init()
        }
      }
    },
    data () {
      return {
        form:{
          group:'',//相册
          type:'',//稿件类型
          track:'',//赛道
          tag:'',//主题
          datetime:'',
          orderBy:'',
          isHide:'',//是否隐藏
          snRange:'',//编号范围
        },
        formArray:[],
        drawer: false,
        //draftinfo:{activityAuth:{}},
        tabs:[],
        materialTypes:{
          1:'照片',
          2:'视频',
          5:'音频',
          3:'文字',
          4:'文档',
          Picture:'照片',
          Video:'视频',
          Audio:'音频',
          Word:'文字',
          Document:'文档',
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        hasTrackLavelMore:false,//多级赛道
        trackOptions:[],
      }
    },
    mounted(){
        this.init()
    },
    methods:{
      async init(){
        this.initParams()
        this.getGroup()
        if(!this.draftinfo){
          await this.getDetail()
        }
        this.trackInit()
      },
      async getDetail(){
        let res=await App.Contribution.GetContributionById({activityId:this.id})
        this.draftinfo=res.data
      },
      trackInit(){
        if (this.draftinfo.activityAuth.isTrack!=1) return;
        let hasTrackLavelMore=false
        let trackOptions=[{
          value: "",
          label: "全部",
        }]
        this.draftinfo.trackList.forEach(track=>{
          let opt={
            value: track.id,
            label: track.name,
          }
          if(track.childList.length>0){
            hasTrackLavelMore=true
            opt.children=[{
              value: "",
              label: "全部",
            }]
            track.childList.forEach(child=>{
              opt.children.push({
                value: child.id,
                label: child.name,
              })
            })
          }
          trackOptions.push(opt)
        })
        this.hasTrackLavelMore=hasTrackLavelMore
        this.trackOptions=trackOptions
      },
      getGroup() {
        let activityId=this.id||this.draftinfo.activityId
        App.Contribution.GetGroupByContribution({
          cid: activityId,
        }).then(json => {
          let tabs=[
            {
              id:'',
              name:'全部投稿',
              type:'sys'
            },
            {
              id:'commentCount',
              name:'热门',
              type:'sys'
            },
          ]
          if (json.code == 200) {
            tabs = tabs.concat(json.data)
          }
          this.tabs=tabs
        })
      },
      handleClose(done) {
        this.formArrayFormat()
        done();
      },
      formArrayFormat(){
        let activityId=this.id||this.draftinfo.activityId
        let formArray=[]
        let params={
          activityId: activityId,
          pageIndex: 1,
          pageSize: 20,
          orderOption:'',
        }
        Object.keys(this.form).forEach(key=>{
          let val=this.form[key]
          if(!val) return;
          let obj={
            key:key,
            val:val,
            name:key+'-'+val,
          }
          switch (key){
            case 'group':

              this.tabs.some(tab=>{
                if(tab.id==val){
                  obj.name=tab.name
                  if(tab.type=='sys'){
                    params.orderOption=val
                  }else{
                    params.wardingId=val
                  }
                  return true
                }
              })
              break;
            case 'type':
              params.materialType=val+'MaterialType'
              obj.name=this.materialTypes[val]
              break;
            case 'track':
              console.error(val)
              if(this.hasTrackLavelMore){
                this.draftinfo.trackList.some(track=>{
                  if(track.id==val[0]){
                    params.trackId=val[0]
                    obj.name=track.name
                    if(val[1]){
                      track.childList.some(ch=>{
                        if(ch.id==val[1]){
                          params.trackId=val[1]
                          obj.name+='/'+ch.name
                          return true
                        }
                      })
                    }
                    return true
                  }
                })
              }else{
                this.draftinfo.trackList.some(track=>{
                  if(track.id==val){
                    params.trackId=val
                    obj.name=track.name
                    return true
                  }
                })
              }
              break;
            case 'tag':
              this.draftinfo.tagList.some(tag=>{
                if(tag.id==val){
                  params.tagId=val
                  obj.name=tag.name
                  return true
                }
              })
              break;
            case 'datetime':
              params.startTime=App.unixtoTime(val[0]/1000,"YYYY-MM-DD HH:II:SS")
              params.endTime=App.unixtoTime(val[1]/1000,"YYYY-MM-DD HH:II:SS")
              obj.name=App.unixtoTime(val[0]/1000,'MM/DD HH:II')+'-'+App.unixtoTime(val[1]/1000,'MM/DD HH:II')
              break;
            case 'orderBy':
              params.orderOption=val
              obj.name={'likeCount':'按点赞量排序','gainVotes':'按投票数量排序'}[val]
              break;
            case 'isHide':
              params.isHide=val
              obj.name=['未隐藏','已隐藏'][val]
              break;
            case 'snRange':
              let range=val.split('-')
              if(range[0]){
                params.startSerialNumber=range[0]
              }
              if(range[1]){
                params.endSerialNumber=range[1]
              }
              obj.name='编号 '+val
              break;
          }
          formArray.push(obj)
        })
        this.formArray=formArray
        this.emitEvent(params)
      },
      emitEvent(params){
        let hasEmit=false
        let activityId=this.id||this.draftinfo.activityId
        if(!this.params){
          this.params={
            activityId: activityId,
            pageIndex: 1,
            pageSize: 20,
            orderOption:'',
          }
        }
        let keys=Object.keys(params)
        let keys2=Object.keys(this.params)
        if(keys2.length>keys.length){
          keys=keys2
        }
        keys.some(key=>{
          if(params[key]!=this.params[key]){
            console.log('emitEvent',key,params[key],this.params[key])
            hasEmit=true
            return true
          }
        })
        if(hasEmit){
          this.params=JSON.parse(JSON.stringify(params))
          this.$emit('event',{params:this.params})
        }
      },
      closeTag(item){
        console.log('closeTag',item)
        if(item.key=='isHide'){
          this.form.isHide=false
        }else if(item.key=='snRange'){
          this.$refs.snRange.clean()
        }else{
          delete this.form[item.key]
        }
        this.formArrayFormat()
      },
      initParams(){
        this.form={
            group:'',//相册
            type:'',//稿件类型
            track:'',//赛道
            tag:'',//主题
            datetime:'',
            orderBy:'',
          isHide:'',//是否隐藏
          snRange:'',//编号范围
        }
        this.formArray=[]
        this.tabs=[]
      }
    }
  }
</script>
<style>
    .border{
        border: 1px solid #ccc;
        padding: 5px;
        border-radius: 5px;
        margin-right: 5px;
    }
    .el-switch__label{
        white-space:nowrap;
        color: #606266;
    }
    .el-switch__label.is-active{
        color: #606266;
    }
    .option-plane .el-card__body{
        padding: 20px 0;
    }
    .button-success{
        width: 92px;
        height: 25px;
        border: 1px solid #3dc4a7;
        border-radius: 14px;
        line-height: 25px;
        color: #3DC4A7;
        text-align: center;
        cursor: pointer;
    }
    .el-tag-fotoo{
        border-radius: 20px;
        margin-right: 10px;
    }

    .option-plane .el-date-editor .el-range__icon,
    .option-plane .el-date-editor .el-range-separator,
    .option-plane .el-date-editor .el-range__close-icon{
        line-height: 22px;
    }
    .option-plane .el-date-editor--datetimerange.el-input__inner{
        width: 356px;
    }

    .option-plane .el-input__inner{
        height: 30px!important;
        line-height: 30px!important;
    }
    .option-plane .el-date-editor--datetimerange.el-input__inner {
        width: 356px;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/option-plane.vue